import React, { useState } from "react";
import { useActionCentreItems } from "./useActionCentreItems";
import { ActionRequiredStrip } from "./ActionRequiredStrip";
import { ActionCentreDrawer } from "./ActionCentreDrawer";

// QW-39a shell: read-only aggregation only (P1). Inline resolution of any
// item type is P2 and arrives per item type, reusing that type's existing
// flow - not built here. This is the employee's own to-do list (Action
// Centre); it is not the Approval Centre / manager decision surface.
export const ActionCentre = () => {
  const { groups, count, loading } = useActionCentreItems();
  const [open, setOpen] = useState(false);

  if (loading || count === 0) return null;

  return (
    <>
      <ActionRequiredStrip count={count} onClick={() => setOpen(true)} />
      <ActionCentreDrawer
        open={open}
        onClose={() => setOpen(false)}
        groups={groups}
      />
    </>
  );
};
